import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import GamingPopup from "../components/GamingPopup";
import FooterCardsSvg from "../components/FooterCardsSvg";
import FooterBgPattern from "../components/FooterBgPattern";

const Footer = () => {
  const [popupTitle, setPopupTitle] = useState(null);

  const openPopup = useCallback((title) => {
    setPopupTitle(title);
  }, []);

  const closePopup = useCallback(() => {
    setPopupTitle(null);
  }, []);

  return (
    <div className="atheriam-footer">
      <FooterBgPattern />
      <footer className="atheriam-footer__inner">
        <Link to="/" className="atheriam-footer__logo-link" aria-label="Atheriam home">
          <img
            src="/footer-logo.png"
            alt="Atheriam - AI Gaming Blockchain"
            className="atheriam-footer__logo"
          />
        </Link>
        <p className="atheriam-footer__tagline">AI · Gaming · Blockchain</p>

        <div className="atheriam-footer__grid">
          <div>
            <h4>Explore</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/blockchain">Blockchain</Link>
              </li>
              <li>
                <Link to="/gaming">Gaming</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>
              <Link to="/ico">ICO</Link>
            </h4>
            <ul>
              <li>
                <Link to="/whitepaper">Whitepaper</Link>
              </li>
              <li>
                <Link to="/tokenomics">Tokenomics</Link>
              </li>
              <li>
                <button
                  type="button"
                  className="atheriam-footer__ghost-link"
                  onClick={() => openPopup("Staking")}
                >
                  Staking
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4>Support</h4>
            <ul>
              <li>
                <button
                  type="button"
                  className="atheriam-footer__ghost-link"
                  onClick={() => openPopup("FAQs")}
                >
                  FAQs
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="atheriam-footer__ghost-link"
                  onClick={() => openPopup("Contact Us")}
                >
                  Contact Us
                </button>
              </li>
              <li>
                <Link to="/terms">Terms of Service</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="atheriam-footer__bottom">
          <p>2026, Atheriam. All rights reserved.</p>
          <div className="atheriam-footer__socials">
            <a
              href="https://www.instagram.com/atheriamecosystem"
              target="_blank"
              rel="noreferrer"
              aria-label="Atheriam on Instagram"
            >
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a
              href="https://x.com/AtheriamEco"
              target="_blank"
              rel="noreferrer"
              aria-label="Atheriam on X"
            >
              <i className="fa-brands fa-x-twitter"></i>
            </a>
          </div>
          <button
            type="button"
            className="atheriam-footer__ghost-link"
            onClick={() => openPopup("Cookie Settings")}
          >
            Cookie Settings
          </button>
        </div>
      </footer>

      <div className="atheriam-footer__cards" aria-hidden="true">
        <FooterCardsSvg />
      </div>

      <GamingPopup
        open={Boolean(popupTitle)}
        title={popupTitle}
        onClose={closePopup}
      />
    </div>
  );
};

export default Footer;
